export default __webpack_public_path__ + "assets/images/icon-play.41a6c1a9a8c2d564697e363a6f271480.svg";